export const Main = (props) => {
  return (
    <main className='page-body main-strip mt-5 py-5'>
      <div>{props.children}</div>
    </main>
  )
}
